import { findElementRecursive } from './findElementRecursive';
/**
 * Determines if an element, or any of its ancestors, contain the given attribute
 * @param element - element to start searching at
 * @param attribute - the attribute to search for
 * @returns the value of the first instance found
 */
export function elementContainsAttribute(element, attribute) {
    var elementMatch = findElementRecursive(element, function (testElement) { return testElement.hasAttribute(attribute); });
    return elementMatch && elementMatch.getAttribute(attribute);
}
//# sourceMappingURL=elementContainsAttribute.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/icons/node_modules/@uifabric/utilities/lib/dom/elementContainsAttribute.js
// module id = 403
// module chunks = 0